import React from 'react';

const JOURS_SEMAINE = [
  { id: 1, libelle: 'Lundi' },
  { id: 2, libelle: 'Mardi' },
  { id: 3, libelle: 'Mercredi' },
  { id: 4, libelle: 'Jeudi' },
  { id: 5, libelle: 'Vendredi' },
  { id: 6, libelle: 'Samedi' },
];

const PrintScheduleTable = ({ emploi, formatTime }) => {
  return (
    <div className="hidden print:block">
      <table className="w-full border-collapse print:border-0 border border-gray-300 text-sm">
        <thead>
          <tr>
            <th className="print:border-0 border border-gray-300 print:bg-transparent bg-gray-100 py-1 px-2 text-center font-bold">
              Jour
            </th>
            <th className="print:border-0 border border-gray-300 print:bg-transparent bg-gray-100 py-1 px-2 text-center font-bold">
              Horaire
            </th>
            <th className="print:border-0 border border-gray-300 print:bg-transparent bg-gray-100 py-1 px-2 text-center font-bold">
              Module
            </th>
            <th className="print:border-0 border border-gray-300 print:bg-transparent bg-gray-100 py-1 px-2 text-center font-bold">
              Enseignant
            </th>
            <th className="print:border-0 border border-gray-300 print:bg-transparent bg-gray-100 py-1 px-2 text-center font-bold">
              Salle
            </th>
          </tr>
        </thead>
        <tbody>
          {JOURS_SEMAINE.map((jour) => {
            const coursDuJour = emploi.cours.filter(c => c.jour === jour.id);
            return coursDuJour.length > 0 ? (
              coursDuJour.map((cours, index) => (
                <tr key={cours.id}>
                  {index === 0 && (
                    <td 
                      rowSpan={coursDuJour.length} 
                      className="border border-gray-300 py-1 px-2 text-center font-bold"
                    >
                      {jour.libelle}
                    </td>
                  )}
                  <td className="border border-gray-300 py-1 px-2 text-center">
                    {formatTime(cours.heure_debut)} - {formatTime(cours.heure_fin)}
                  </td>
                  <td className="border border-gray-300 py-1 px-2">
                    {cours.module?.libelle || 'Non défini'}
                  </td>
                  <td className="border border-gray-300 py-1 px-2 text-center">
                    {cours.enseignant?.nom_complet || 'Non assigné'}
                  </td>
                  <td className="border border-gray-300 py-1 px-2 text-center">
                    {cours.salle?.libelle || 'Non définie'}
                  </td>
                </tr>
              ))
            ) : (
              <tr key={jour.id}>
                <td className="border border-gray-300 py-1 px-2 text-center font-bold">
                  {jour.libelle}
                </td>
                <td colSpan="4" className="border border-gray-300 py-1 px-2 text-center text-gray-500">
                  Aucun cours programmé
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PrintScheduleTable; 